import { render } from "./DataApps.vue?vue&type=template&id=84d92928"
import script from "./DataApps.vue?vue&type=script&lang=js"
export * from "./DataApps.vue?vue&type=script&lang=js"

import "./DataApps.vue?vue&type=style&index=0&id=84d92928&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DataApps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84d92928"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84d92928', __exports__)) {
    api.reload('84d92928', __exports__)
  }
  
  module.hot.accept("./DataApps.vue?vue&type=template&id=84d92928", () => {
    api.rerender('84d92928', render)
  })

}


export default __exports__